import {UI, StyleSheet, registerStyle, styleRule} from "../../../../../../stem-core/src/ui/UI";
import {Flow} from "../../../../initializeFlows";
import {Messages} from "../../../../../Messages";
import {Controller} from "../../../../Controller";
import {SubscribeFlowState} from "../../../../inline-subscription/SubscribeFlowState";


class SubscriptionOfferPriceStyle extends StyleSheet {
    @styleRule
    price = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
    };

    @styleRule
    offerPrice = {
        display: "flex",
        flexDirection: "row",
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
    };

    @styleRule
    oldOfferPrice = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        textDecoration: "line-through",
        color: this.themeProps.OLD_SUBSCRIBE_OFFER_TEXT_COLOR,
        marginLeft: "auto",
        marginRight: "auto",
    };

    @styleRule
    priceAmount = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    offerCycle = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_LIGHT,
    };

    @styleRule
    finalPriceLine = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_SMALL,
    }
}


@registerStyle(SubscriptionOfferPriceStyle)
export class SubscriptionOfferPrice extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            offer: null,
            displayAfterTaxesPrice: false,
            testId: "subscriptionOfferPrice",
        }
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.price);
    }

    getDiscountedOfferPrice() {
        const {offer} = this.options;

        if (Controller.subscriptionPlan.getDiscountInfo(offer)) {
            const {discountedBeforeTaxesPrice, initialOfferPrice} = Controller.subscriptionPlan.getDiscountInfo(offer);
            return initialOfferPrice !== discountedBeforeTaxesPrice ? discountedBeforeTaxesPrice : null;
        }
        return null;
    }

    render() {
        const {offer, displayAfterTaxesPrice} = this.options;
        const {styleSheet} = this;

        const discountedOfferPrice = this.getDiscountedOfferPrice();
        const initialPrice = offer.getPrice();
        const discountInfo = Controller.subscriptionPlan.getDiscountInfo(offer);
        const discountedBeforeTaxesPrice = SubscribeFlowState.getSubscriptionOfferPrice(offer, discountInfo);
        const finalPrice = offer.formatPrice(discountInfo?.finalPrice);

        return [
            <div className={styleSheet.offerPrice + (discountedOfferPrice ? styleSheet.oldOfferPrice : "")}>
                <div className={styleSheet.priceAmount}>{initialPrice}</div>
                <div className={styleSheet.offerCycle}>/{offer.getCycleDuration(true)}</div>
            </div>,
            discountedOfferPrice ? <div className={styleSheet.offerPrice}>
                    <div className={styleSheet.priceAmount}>{offer.formatPrice(discountedOfferPrice)}</div>
                    <div className={styleSheet.offerCycle}>/{offer.getCycleDuration(true)}</div>
            </div> : null,
            displayAfterTaxesPrice && offer.hasShippingPrice() && !discountedBeforeTaxesPrice.equals(finalPrice) ?
                <div className={styleSheet.offerPrice}>
                    <div className={styleSheet.finalPriceLine}>{Messages.priceIncludingShippingAndTax(`${finalPrice}/${offer.getCycleDuration(true)}`)}</div>
                </div> : null,
        ];
    }
}


class CoveragePricesStyle extends StyleSheet {
    @styleRule
    pricesElement = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        width: "100%",
        alignItems: "center",
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_LIGHT,
    };

    @styleRule
    discountApplied = {
        alignItems: "flex-end",
    };

    @styleRule
    separator = {
        margin: "0px 8px 4px",
    }
}

@registerStyle(CoveragePricesStyle)
export class CoveragePrices extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            offers: [],
            displayAfterTaxesPrice: false,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.pricesElement);
        if (this.isDiscountApplied()) {
            attr.addClass(this.styleSheet.discountApplied);
        }
    }

    isDiscountApplied() {
        const {offers} = this.options;
        return offers && !!offers.find(offer => !!Controller.subscriptionPlan.getDiscountInfo(offer));
    }

    render() {
        return this.options.offers?.filter(offer => offer != null).reduce((acc, offer, index) => [
            ...acc,
            index === 0 ? "" : <div className={this.styleSheet.separator}>or</div>,
            <SubscriptionOfferPrice offer={offer} displayAfterTaxesPrice={this.options.displayAfterTaxesPrice} />
        ], []);
    }
}
